export const api_link =
  "https://api.hsforms.com/submissions/v3/integration/submit/8161231/b54af128-bd44-46a4-9179-2124498762f0";
const local = {
  info: {
    REACT_APP_WEBSITE_URL: "https://xenonstack-ai-dev.neuralcompany.team/",
  },
};

const dev = {
  auth: {
    REACT_APP_AUTH_URL: "https://xenonstack-ai-auth.lab.neuralcompany.team",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".neuralcompany.team",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://xenonstack-ai-dev.neuralcompany.team/",
  },
};

const prod = {
  auth: {
    REACT_APP_AUTH_URL: "https://application.xenonstack.ai",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".xenonstack.ai",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.xenonstack.ai/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : 
      local;
// eslint-disable-next-line
export default {
  ...config,
};

console.log(config,"stage")
console.log(process.env.REACT_APP_STAGE,"REACT_APP_STAGE")
